// extracted by mini-css-extract-plugin
module.exports = {"freight-dictionary":"FreightDictionary_freight-dictionary__Ql_jc","container":"FreightDictionary_container__Q8WLo"};